
export enum DamageTypeCd {
	CONCEALED = 'Concealed',
	WRECK_AND_FIRE = 'WreckAndFire'}

